import { useSelector } from "react-redux";

import styles from "./LatestResultsBar.module.css";

import elementsJsonData from "../../../assets/traitInfo/elements.json";
import patternsJsonData from "../../../assets/traitInfo/patterns.json";

import { RootState } from "@/redux/store";
import { ElementNoBorderOrName } from "@/components/traits/element/Element/Element";
import { PatternWithoutBorder } from "@/components/traits/pattern/Pattern/Pattern";
import { LatestResultDetail } from "@dimensional-engineering/dimensional-models";
import { useModalContext } from "@/context/ModalContext";
import TraitAssessmentOutro from "@/components/TraitAssessment/TraitAssessmentOutro/TraitAssessmentOutro";
import TraitsAssessmentModal from "@/components/TraitAssessment/TraitsAssessmentModal/TraitsAssessmentModal";

export default function TraitAssessmentLatestResultBlock(props: {
  result: LatestResultDetail;
}) {
  const { setModalComponent } = useModalContext();

  const isUserPremium = useSelector((state: RootState) => state.user.isPremium);

  const traitResults = useSelector(
    (state: RootState) => state.scheduledAssessments.traitAssessmentResults
  );

  const foundResult = traitResults.find(
    (r) =>
      r.scheduleIdentifier ===
      props.result.traitAssessmentResult?.scheduleIdentifier
  );

  const element = elementsJsonData.find(
    (e) => e.slug === foundResult?.definitionTraitIdentifier.slug
  );
  const pattern = patternsJsonData.find(
    (p) => p.slug === foundResult?.definitionTraitIdentifier.slug
  );

  return (
    <div
      onClick={() => {
        if (foundResult) {
          if (!foundResult.traitAssessmentLlmData && isUserPremium) {
            return setModalComponent(
              <TraitsAssessmentModal
                type={element ? "element" : "pattern"}
                slug={element ? element.slug : pattern?.slug ?? ""}
                hidden
                elementName="TraitsAssessmentModal"
              />
            );
          }
          return setModalComponent(
            <TraitAssessmentOutro
              traitAssessmentResult={foundResult}
              type={element ? "element" : "pattern"}
              slug={element ? element.slug : pattern?.slug ?? ""}
              isPremium={element ? element.isPremium : pattern?.isPremium}
              source="latest results item"
            />
          );
        }
      }}
      className={styles.block}
    >
      <p className={styles.topText}>Score updated</p>
      <div
        style={
          element ? {} : { marginTop: "0", height: "37px", maxHeight: "37px" }
        }
        className={styles.elementAndPAtternDiv}
      >
        {element ? (
          <ElementNoBorderOrName slug={element.slug} />
        ) : (
          <PatternWithoutBorder patternSlug={pattern?.slug ?? ""} />
        )}
      </div>
      <p className={styles.bottomText}>
        {element ? element.alias ?? element.name : pattern?.name}
      </p>
    </div>
  );
}
